import { useEffect, useState } from "react";
import Head from "src/components/molecules/Head";
import WidgetLandscape from "src/components/templates/WidgetLandscape";
import WidgetPortrait from "src/components/templates/WidgetPortrait";
import { useRouter } from "src/hooks/useRouter";
import EventSearch from "src/services/EventSearch";
import { usePluginConfig } from "../contexts/pluginContext";
import { getRandomIntInclusive } from "../utils/random";

const WidgetPage = () => {
	const [apiLoading, setApiLoading] = useState(true);
	const pluginConfig = usePluginConfig();
	const publisherSettings = pluginConfig.publisherSettings;
	const frameConfig = pluginConfig.frameConfig;
	const router = useRouter();
	const [rawEvents, setRawEvents] = useState([]);
	const [adPosition, updateAdPosition] = useState(null);

	const shouldDisplayAd = () => {
		return (
			frameConfig.options.number > 2 &&
			publisherSettings?.publisher?.promotional_assets?.some(
				(asset) =>
					asset.asset_unit ===
					(frameConfig.options.landscape
						? "horizontal_widget"
						: "vertical_widget"),
			)
		);
	};

	useEffect(() => {
		const prepareData = async () => {
			const searchClient = new EventSearch({ context: router, pluginConfig });
			const eventsToDisplay = shouldDisplayAd()
				? frameConfig.options.number - 1
				: frameConfig.options.number;
			const rawEvents = await searchClient.widgetEvents({
				widgetNumber: eventsToDisplay,
				categoryId: frameConfig.options.category_id,
			});

			setRawEvents(rawEvents);

			if (shouldDisplayAd()) {
				// The ad can be placed anywhere in the list, except the first and last position
				updateAdPosition(getRandomIntInclusive(1, rawEvents.length - 1));
			}
		};

		prepareData().then(() => {
			setApiLoading(false);
		});
	}, []);

	return (
		<>
			<Head publisherSettings={publisherSettings} />
			{frameConfig.options.landscape ? (
				<WidgetLandscape
					rawEvents={rawEvents}
					category={router.query.category}
					apiLoading={apiLoading}
					frameConfig={frameConfig}
					adPosition={adPosition}
				/>
			) : (
				<WidgetPortrait
					rawEvents={rawEvents}
					category={router.query.category}
					apiLoading={apiLoading}
					adPosition={adPosition}
				/>
			)}
		</>
	);
};

export default WidgetPage;
